<template>
  <Modal class-name="vertical-center-modal" v-model="isModal" title="提示" width="360">
    <div class="form-wrapper">
      <div class="tip-wrap">
        <div>请填写驳回原因：</div>
        <div class="padding-t-10">
          <textarea style="border: 1px solid #C1C1C1;" cols="35" rows="5" v-model="remark" v-bind:maxlength="Surplus" v-on:input="content()" v-on:compositionstart="importStart()" v-on:compositionend="importEnd()" placeholder="必填,1-100个字符"></textarea>
        </div>
      </div>
    </div>
    <div slot="footer">
      <div class="footer-wrapper">
        <span class="btn confirm-btn" @click="handelSubmit">确定</span>
      </div>
    </div>
    <Spin size="large" fix v-show="loading"></Spin>
  </Modal>
</template>

<script>
  import { Modal, Spin } from 'view-design'
  import commission from '@/javaApi/commission'
  const commissionModel = new commission()
  export default {
    name: "Reject",
    components: {
      Modal,
      Spin
    },
    data: function() {
      return {
        isModal: false,
        loading: false,
        withdraw_id: '',
        remark: '',
        Surplus: 100,
        conterNum: 0,
        cInput: false,
      }
    },
    watch:{

    },
    methods: {
      init: function(isModal, id) {
        this.loading = true
        this.isModal = isModal
        this.withdraw_id = id
        this.loading = false
      },
      handelSubmit:function(){
        commissionModel.rejectWithdraw({id:this.withdraw_id,remark:this.remark}).then((response) => {
          var res = response.data
          if(res.code != 200){
            this.$Message.error(res.message?res.message:'系统异常请稍后再试！')
            return
          }
          this.$Message.success('驳回成功！');
          this.isModal = false;
          this.$emit('refreshList');
        })
      },
      content() {
        let self = this;
        if (self.cInput == false) {
          self.conterNum = self.remark.length;
        }
      },
      importStart() {
        this.cInput = true;
      },
      importEnd() {
        this.cInput = false;
      },
    }
  }
</script>

<style scoped>
  >>>.vertical-center-modal {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  >>>.vertical-center-modal .ivu-modal {
    top: 0;
    width: 300px;
  }

  >>>.vertical-center-modal .ivu-modal-footer {
    border-top: none;
    padding: 12px 18px 12px 18px;
    text-align: right;
  }
  .form-wrapper .tip-wrap{
    padding: 20px;
  }
  .footer-wrapper {
    display: flex;
    min-width: 0;
    width: 100%;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }

  .footer-wrapper .btn {
    display: inline-block;
    border-radius: 4px;
    margin-right: 10px;
    padding: 0px 15px;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    vertical-align: middle;
    cursor: pointer;
  }

  .footer-wrapper .btn.confirm-btn {
    background: #ff8622;
    color: #fff;
  }

  .footer-wrapper .btn.cancel-btn {
    border: 1px solid #eeeeee;
    border-radius: 2px;
    color: #222222;
  }
</style>



// WEBPACK FOOTER //
// src/views/pc/official/commission/modal/Reject.vue